var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"items-menu-container"},[_c('div',{staticClass:"items-menu-list"},[(_vm.isLoading)?_c('WaitingBlock'):_vm._t("Content")],2),(!_vm.noAction)?_c('div',{staticClass:"actions"},[_vm._t("Actions")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }